import {
    AfterViewInit,
    ChangeDetectorRef,
    DestroyRef,
    Directive,
    ElementRef,
    HostListener,
    inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FullscreenService } from './fullscreen.service';

@Directive({
    selector: '[flFullscreenTrigger]',
})
export class FullscreenTriggerDirective implements AfterViewInit {
    private service = inject(FullscreenService);
    private el = inject(ElementRef);
    private destroyRef = inject(DestroyRef);
    private cd = inject(ChangeDetectorRef);

    ngAfterViewInit() {
        this.service.isAvailable$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isAvailable) => {
            if (!this.el) {
                return;
            }
            (this.el.nativeElement as HTMLElement).style.display = !isAvailable ? 'none' : '';
            this.cd.detectChanges();
        });
    }

    @HostListener('click') public onClick() {
        this.service.setIsFullscreen(true);
    }
}
